import { MatchesTab } from "components/Tabs/MatchesTab";
import { StatsTab } from "components/Tabs/Tournament/StatsTab";
import { TournamentOverviewTab } from "components/Tabs/Tournament/TournamentOverviewTab";
import { Filter } from "model/Filter/Filter";
import {
  getCombinedTournamentSegmentNames,
  getTournamentMatchIds,
  getTournamentSegmentIdsFromName,
  Tournament,
} from "model/Tournament/Tournament";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Panel } from "components/Panel/Panel";
import { buildTournamentPath } from "pages/PageConfigs";
import { SingleColumnPage } from "pages/PageTemplates";
import { ColumnContainer, GrowColumn } from "pages/styles";
import { EmptyGrowPanelText } from "styles/text";
import { TournamentSegmentTab } from "components/Tabs/Tournament/Segment/TournamentSegmentTab";
import { Theme } from "model/Theme";
import { Banner, MobileBanner } from "./styles";
import { TournamentHeader } from "components/Tabs/Tournament/TournamentHeader";

interface Props {
  tournament: Tournament;
  tabName: string | undefined;
}
export const TournamentPageContent = ({ tournament, tabName }: Props) => {
  const tabOptions = [
    "Overview",
    ...getCombinedTournamentSegmentNames(tournament),
    "Matches",
    "Stats",
  ];

  const [selectedTab, setSelectedTab] = useState(
    !!tabName && tabOptions.includes(tabName) ? tabName : tabOptions[0]
  );
  const tabFilter: Filter<string> = {
    options: tabOptions,
    selectedValue: selectedTab,
    setSelectedValue: setSelectedTab,
  };

  const navigate = useNavigate();
  useEffect(() => {
    navigate(buildTournamentPath(tournament.id, selectedTab), {
      replace: true,
    });
  }, [selectedTab]);

  return (
    <SingleColumnPage>
      {tournament.id.startsWith("Bymc") && (
        <>
          <Banner src="/images/tournaments/BYMC/banner.jpg" />
          <MobileBanner src="/images/tournaments/BYMC/banner_mobile.jpg" />
        </>
      )}
      <Panel>
        <TournamentHeader tournament={tournament} tabFilter={tabFilter} />
      </Panel>
      <ColumnContainer>
        {getTabContent(
          tabFilter.selectedValue,
          tournament,
          tournament.id,
          tournament.theme
        )}
      </ColumnContainer>
    </SingleColumnPage>
  );
};

const getTabContent = (
  selectedTab: string,
  tournament: Tournament,
  tournamentId: string,
  theme: Theme | undefined
) => {
  switch (selectedTab) {
    case "Overview":
      return (
        <TournamentOverviewTab key={selectedTab} tournament={tournament} />
      );
    case "Matches":
      return (
        <MatchesTab
          key={selectedTab}
          matchIds={getTournamentMatchIds(tournament)}
          theme={theme}
        />
      );
    case "Stats":
      return <StatsTab tournamentId={tournamentId} theme={theme} />;
    default:
      const segmentIds = getTournamentSegmentIdsFromName(
        tournament,
        selectedTab
      );

      if (!segmentIds) {
        return (
          <GrowColumn>
            <Panel>
              <EmptyGrowPanelText>Unable to find segment</EmptyGrowPanelText>
            </Panel>
          </GrowColumn>
        );
      }

      return (
        <TournamentSegmentTab
          key={selectedTab}
          tournamentId={tournamentId}
          segmentIds={segmentIds}
          theme={theme}
        />
      );
  }
};
